<template>
  <div>
    <el-row>
      <el-col :lg="3"
        ><el-button
          type="primary"
          size="medium"
          @click="goBack"
          class="backButton"
        >
          Back
        </el-button>
      </el-col>
      <el-col :lg="18"
        ><el-card class="oauth-container">
          <div class="app-content">
            <img
              :src="iconsUrl + appSelected.logo"
              alt="App Logo"
              class="all-app-logo"
            />
            <span class="all-apps">{{ appSelected.label }}</span>
            <el-divider />
            <integrationsRequiredFields
              v-if="hasConnection"
              :application="appSelected"
              :fields="requiredFields"
              :connection="connection"
              :form="form"
            ></integrationsRequiredFields>
            <el-form
              label-position="top"
              class="connection-form"
              :model="formData"
              ref="formData"
              v-else
            >
              <el-form-item
                prop="connectionName"
                label="New Connection Name"
                required
                class="connection-form-item"
              >
                <el-input
                  size="large"
                  v-model="formData.connectionName"
                  placeholder="Enter connection name"
                  class="connection-input"
                />
              </el-form-item>
              <el-button
                type="primary"
                size="medium"
                @click="connectNewAccount"
                class="connect-account-btn"
              >
                + Connect New Account with {{ appSelected.label }}
              </el-button>
            </el-form>
          </div>
        </el-card></el-col
      >
    </el-row>
  </div>
</template>

<script>
import store from "@/store/index";
import { mapGetters } from "vuex";
import integrationsRequiredFields from "./integrationsRequiredFields.vue";
export default {
  name: "IntegrationsOauthApplications",
  props: {
    hasConnection: Boolean,
    appSelected: {
      type: Object,
      required: true,
    },
    connection: {
      type: Object,
      required: true,
    },
  },
  components: { integrationsRequiredFields },
  data() {
    return {
      formData: { connectionName: "" },
      queryData: null,
      interval: null,
      formRules: {
        connectionName: [
          {
            required: true,
            message: "Connection name is required",
            trigger: "blur",
          },
        ],
      },
      form: {},
    };
  },
  created() {
    this.interval = setInterval(this.checkLocalStorage, 2000);
  },
  watch: {
    async queryData(newValue) {
      if (newValue) {
        await this.getTokensUsingAuthorizationCode(newValue);
      }
    },
  },
  computed: {
    ...mapGetters("globalApis", [
      "getIntegrationOauthTokens",
      "getexchangeCodeForToken",
      "getApplicationDetails",
    ]),
    requiredFields() {
      return this.appSelected.settings.requiredFields &&
        this.appSelected.settings.requiredFields.length
        ? this.appSelected.settings.requiredFields
        : [];
    },
    iconsUrl() {
      return process.env.VUE_APP_ICONS_BASE_URL;
    },
  },
  methods: {
    goBack() {
      let params = {
        redirect_url: this.$route.query.redirect_url,
        state: this.$route.query.state,
      };
      this.$router.push({
        path: "/all-integrations",
        query: params,
      });
    },
    async checkLocalStorage() {
      let storageInfo = await localStorage.getItem("integrationCode");
      this.queryData = await JSON.parse(storageInfo);
      await localStorage.removeItem("integrationCode");
    },
    async connectNewAccount() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          await store.dispatch(
            "globalApis/getIntegrationOauthTokens",
            this.appSelected?._id
          );
          if (
            this.getIntegrationOauthTokens &&
            this.getIntegrationOauthTokens.authUrl
          ) {
            window.open(
              this.getIntegrationOauthTokens.authUrl,
              "_blank",
              "width=800,height=600"
            );
          }
        } else {
          return false;
        }
      });
    },
    async getTokensUsingAuthorizationCode(value) {
      let app = this.appSelected;
      let params = {
        CustomState: this.$route.query.state,
        appId: app._id,
        name: this.formData.connectionName,
        isIncludeTokens: app.settings.isOauthAuthenticating,
      };
      params = { ...params, ...value };
      await store.dispatch("globalApis/getexchangeCodeForToken", params);
      if (this.getexchangeCodeForToken.status) {
        this.$notify.success({
          title: "Success",
          message: "Connection established successfully",
        });
        if (
          app.settings &&
          app.settings.requiredFields &&
          app.settings.requiredFields.length
        ) {
          this.$emit("activateConnection", this.getexchangeCodeForToken.data);
        } else {
          window.open(
            `${this.$route.query.redirect_url}?state=${this.$route.query.state}`,
            "_self"
          );
        }
      } else {
        this.$notify.error({
          title: "Error",
          message: "Error in establishing connection",
        });
      }
    },
  },
};
</script>

<style scoped>
.backButton {
  margin-left: 5%;
}
.oauth-container {
  max-width: 70%;
  margin: 40px auto;
  padding: 30px;
  border-radius: 8px;
  background-color: #ffffff;
  position: relative;
  bottom: 76px;
}

.app-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.all-app-logo {
  width: 5rem;
  height: 9rem;
  object-fit: contain;
  margin-bottom: 0.5rem;
}

.all-apps {
  font-size: 19px;
  font-weight: bold;
  color: #333;
  margin-bottom: -1.5rem;
  position: relative;
  bottom: 20px;
}

.connection-form-item >>> .el-form-item__label {
  font-weight: 600;
  font-size: 14px;
  color: #2c3e50;
  margin-bottom: 0;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  position: relative;
  bottom: 0;
}

.connection-form-item >>> .el-form-item__label::after {
  content: "";
  display: block;
  width: 40px;
  height: 2px;
  margin-top: 4px;
  border-radius: 1px;
  transition: width 0.3s ease;
}
.connection-form {
  width: 100%;
  margin-top: 1.5rem;
  bottom: 12px;
  position: relative;
}

.connection-form-item {
  width: 100%;
  margin-bottom: 1.5rem;
}

.connection-input >>> .el-input__inner {
  font-size: 13px;
  padding: 10px -6px;
  transition: border-color 0.3s;
  position: relative;
}

.connect-account-btn {
  width: 100%;
}

.connect-account-btn:hover {
  background-color: #409eff !important;
  color: white !important;
}

.back-button {
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #409eff !important;
  color: white !important;
}
</style>
